<script setup>
import { computed, useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

const logoThumbnailSrc = computed(() => {
  const logoThumbnail = globalConfig.logoThumbnail;
  if (typeof logoThumbnail !== 'string' || !logoThumbnail) {
    return '/brand-assets/logo_thumbnail.svg';
  }

  return logoThumbnail.replace(
    /(\/brand-assets\/logo_thumbnail)\.png(\?.*)?$/,
    '$1.svg$2'
  );
});
</script>

<template>
  <img v-bind="attrs" :src="logoThumbnailSrc" />
</template>
